export default __webpack_public_path__ + "static/media/trash.2c2918a0.svg";